import { Box, VStack } from '@chakra-ui/react';
import maps from '@common/maps';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import React, { useEffect } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

import { SectionHeader } from '../common/SectionHeader';

type TheMarketProps = {
  children?: React.ReactNode;
};

export const TheMarket: React.FC<TheMarketProps> = () => {
  const { property } = usePropertiesModel();

  useEffect(() => {
    if (property?.sfr?.info.lat_long) {
      const latLong = { lat: Number(property?.sfr?.info.lat_long.lat), lng: Number(property?.sfr?.info.lat_long.long) };

      maps.load(
        'map',
        {
          center: latLong,
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          zoom: 13,
          zoomControl: false,
        },
        (map) => {
          maps.marker({
            map,
            position: latLong,
            title: 'test',
          });
        },
      );
    }
  }, [property]);

  return (
    <VStack alignItems={'flex-start'} gap="40px">
      <SectionHeader text="The Market" />
      <Box id="map" w={'100%'} height="262px" borderRadius={'10px'}></Box>
      {property?.sfr?.market_data.summary && (
        <TextBlock fontSize="20px" lineHeight={'30px'} whiteSpace={'pre-wrap'}>
          {property?.sfr?.market_data.summary}
        </TextBlock>
      )}
    </VStack>
  );
};
